import { render, staticRenderFns } from "./Ver-informe.vue?vue&type=template&id=1d25fb2f&scoped=true"
import script from "./Ver-informe.vue?vue&type=script&lang=js"
export * from "./Ver-informe.vue?vue&type=script&lang=js"
import style0 from "./Ver-informe.vue?vue&type=style&index=0&id=1d25fb2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d25fb2f",
  null
  
)

export default component.exports